<template>
<div class="successDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' title="提示" :visible.sync="dialogVisible" width="650px">
        <div class="successDialog-header">
            <div class="successDialog-tip">活动发布成功，请前往商品设置进行添加商品</div>
            <div>
                <el-button type="primary" @click="handleEditGoods">设置商品</el-button>
            </div>
        </div>
        <div class="successDialog-content" v-if="hostroletype==2">
            <div class="successDialog-tip">您也可以通过复制下面链接进行分享</div>
            <div class="successDialog-outbox">
                <div class="box">
                    <img v-lazy="item.base64eventdetailurl" alt="" class="img">
                    <div @click="download(item.base64eventdetailurl, '活动详情')" class="pointer">下载<span class="tc-blue">活动详情</span>二维码</div>
                    <el-input v-model="item.eventdetailurl" disabled></el-input>
                    <el-button type="primary" v-clipboard:copy="item.eventdetailurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </div>
                <div class="box">
                    <img v-lazy="item.base64hostrolepageurl" alt="" class="img">
                    <div @click="download(item.base64hostrolepageurl, '身份主页')" class="pointer">下载<span class="tc-blue">身份主页</span>二维码</div>
                    <el-input v-model="item.hostrolepageurl" disabled></el-input>
                    <el-button type="primary" v-clipboard:copy="item.hostrolepageurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {urlToQRCode, downloadImage} from 'common/js/tools'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'successDialog',
    props: ['hostroletype'],
    data() {
        return {
            dialogVisible: false,
            item: {
                eventid: '',
                eventdetailurl: '',
                base64hostrolepageurl: '',
                eventdetailurl: '',
                base64hostrolepageurl: ''
            }
        }
    },
    mounted() {
    },
    methods: {
        download(imgsrc, name) {
            downloadImage(imgsrc, name)
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        onError(e) {
            alert('失败')
        },
        handleEditGoods() {
            this.dialogVisible = false
            if (this.hostroletype == 2) {
                this.$router.push({name: 'BBActivityGoodsList', query: {eventid: this.item.eventid, hostroletype: this.hostroletype}})
            } else {
                this.$router.push({name: 'SPActivityTempGoodsList', query: {eventid: this.item.eventid, hostroletype: this.hostroletype}})
            }

        },
        openDialog(eventid, eventdetailurl, hostrolepageurl, hostroletype) {
            this.item.eventid = eventid
            this.item.eventdetailurl = eventdetailurl
            this.item.hostrolepageurl = hostrolepageurl
            this.item.base64eventdetailurl = urlToQRCode(eventdetailurl)
            this.item.base64hostrolepageurl = urlToQRCode(hostrolepageurl)
            this.hostroletype = hostroletype
            this.dialogVisible = true
        },
        cancel() {
            this.dialogVisible = false
            this.$router.back()
        },
        ...mapActions([
            'setLoading', 'setPage'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.successDialog {
    text-align: center;
    .pointer{
        cursor: pointer;
    }
    .successDialog-header{
        border-bottom: 1px solid #DCDFE6;
        .successDialog-tip{
            margin-bottom: 30px;
        }
    }
    .successDialog-content{
        .successDialog-tip{
            margin-top: 30px;
        }
        .successDialog-outbox{
            margin-top: 20px;
            display: flex;
            justify-content: center;
            .box{
                display: flex;
                flex-direction: column;
                align-items: center;
                .img{
                    width: 160px;
                    height: 160px;
                    margin-bottom: 20px;
                }
                .el-input{
                    margin: 20px 0;
                    width: 160px;
                }
                .el-button{
                    width: 160px;
                }
            }
            .box+.box{
                margin-left: 160px;
            }
        }
    }
}
</style>
